var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7148 9.88867C20.7148 10.5215 20.1875 11.0137 19.5898 11.0137H18.4648L18.5 16.6387C18.5 16.7441 18.5 16.8496 18.5 16.9199V17.4824C18.5 18.291 17.8672 18.8887 17.0938 18.8887H16.5312C16.4609 18.8887 16.4258 18.8887 16.3906 18.8887C16.3555 18.8887 16.2852 18.8887 16.25 18.8887H14.2812C13.4727 18.8887 12.875 18.291 12.875 17.4824V14.3887C12.875 13.791 12.3477 13.2637 11.75 13.2637H9.5C8.86719 13.2637 8.375 13.791 8.375 14.3887V17.4824C8.375 18.291 7.74219 18.8887 6.96875 18.8887H5C4.92969 18.8887 4.89453 18.8887 4.82422 18.8887C4.78906 18.8887 4.75391 18.8887 4.71875 18.8887H4.15625C3.34766 18.8887 2.75 18.291 2.75 17.4824V13.5449C2.75 13.5449 2.75 13.5098 2.75 13.4746V11.0137H1.625C0.992188 11.0137 0.5 10.5215 0.5 9.88867C0.5 9.57227 0.605469 9.29102 0.851562 9.04492L9.85156 1.20508C10.0977 0.958984 10.3789 0.888672 10.625 0.888672C10.8711 0.888672 11.1523 0.994141 11.3633 1.16992L20.3281 9.04492C20.6094 9.29102 20.75 9.57227 20.7148 9.88867Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default ForwardRef;